/**
 * BriefEmptyState (v1.8.0) — shown when a post has no `designAssetBrief`
 * yet (legacy posts). Single CTA dispatches the regenerate-brief endpoint.
 */

import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export interface BriefEmptyStateProps {
  onGenerate: () => Promise<void> | void;
  busy?: boolean;
}

export const BriefEmptyState: React.FC<BriefEmptyStateProps> = ({ onGenerate, busy = false }) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      data-testid="design-brief-empty"
    >
      <Stack spacing={0.5}>
        <Typography variant="subtitle2">No design brief yet</Typography>
        <Typography variant="caption" color="text.secondary">
          Generate a behaviour-driven brief (audience, message, storyboard) for this post.
        </Typography>
      </Stack>
      <Button
        variant="contained"
        size="small"
        onClick={() => {
          void onGenerate();
        }}
        disabled={busy}
        data-testid="design-brief-empty-generate"
      >
        Generate brief
      </Button>
    </Stack>
  );
};
